/// <reference types="gtag.js" />
const gtag: Gtag.Gtag = function (command, ...args) {
  if (window.gtag) {
    window.gtag(command, ...args);
  } else {
    console.info("gtag", JSON.stringify([command, ...args], null, 2));
  }
};

export default gtag;
